export default __webpack_public_path__ + "static/media/optimiser.6e7f11b4.svg";